import React from 'react'
import PropTypes from 'prop-types'
import Modal from '../ui/Modal'
import SchemaForm from '../SchemaForm'
import LoadingButton from '../ui/LoadingButton'
import { connect } from 'react-redux'
import { save, remove } from '../../actions/groups'

const schema = {
  name: {
    required: true
  }
}

@connect(null)
export default class extends React.Component {
  static contextTypes = {
    site: PropTypes.object.isRequired
  }

  onSubmit = async value => {
    const {site} = this.context
    const {dispatch, group} = this.props

    await dispatch(save(value, site.id, group.id))

    this.props.onDismiss()
  }

  onDelete = async (e) => {
    e.preventDefault()
    const {dispatch, group} = this.props

    await dispatch(remove(group))

    this.props.onDismiss()
  }

  dismiss = (e) => {
    e.preventDefault()
    this.props.onDismiss()
  }

  render () {
    const {showing, group} = this.props

    return <Modal showing={showing}>
      <div className='modal-title'>
        {group && group.id
          ? 'Edit Group'
          : 'Create Group'
        }
      </div>
      <div className='modal-block'>
        <SchemaForm schema={schema} value={group}
          onSubmit={this.onSubmit}
          button={({ui}) => <div className='modal-links text-right'>
            {group && group.id &&
              <a role='button' onClick={this.onDelete} className='text-danger'>Delete Group</a>
            }
            <button type='button' onClick={this.dismiss}>Cancel</button>
            <LoadingButton className='btn-save' type='submit' ui={ui}>Save</LoadingButton>
          </div>}
        />
      </div>
    </Modal>
  }
}



// WEBPACK FOOTER //
// ./app/components/sidebar/GroupForm.js